<template>
    <v-container>
        <v-carousel
            :cycle="cycle"
            :height="350"
            style="text-align: center;"
            hide-delimiters
            show-arrows-on-hover
            :interval="10000"
        >
            <v-carousel-item
                @mouseenter="setCycle(false)"
                @mouseleave="setCycle(true)"
                class="placeholder-container"
                v-for="(themeValue, i) in newTheme"
                :key="i"
            >
                <color-picker :index="i" @color-change="updateThemeColor" :theme="themeValue" />
            </v-carousel-item>
        </v-carousel>
    </v-container>
</template>

<script>
import ColorPicker from './ColorPicker.vue';

export default {
    components: {
        'color-picker': ColorPicker
    },
    props: {
        theme: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        newTheme: null,
        cycle: true,
    }),
    created() {
        this.newTheme = JSON.parse(JSON.stringify(this.theme));
    },
    methods: {
        setCycle(state) {
            this.cycle = state;
        },
        updateThemeColor(theme) {
            this.$emit('color-change', theme);
        }
    }
}
</script>
